import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { getInvitationDataTableStructure } from './utils/invitation-data-table-object';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { User } from '@/types';
import { Participant } from '@/types/meeting.types';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sm-invitation-data-table',
  imports: [DataTableBuilderComponent, CommonModule],
  templateUrl: './invitation-data-table.component.html',
  styleUrl: './invitation-data-table.component.scss',
})
export class InvitationDataTableComponent implements OnInit, OnChanges {
  meetingRepository = inject(MeetingRepository);
  @Input() createAction?: () => void;
  @Input() members?: User[];
  @Input() isComLoading?: BehaviorSubject<boolean>;
  @Input() isStatusPlanned?: boolean;

  rowActions: DataTableRowActions = {
    deleteAction: (row: any) => {
      this.removeParticipant(row);
    },
  };

  dataTableObject: DynamicDataTable = getInvitationDataTableStructure({
    createAction: () => this.createAction?.(),
    rowActions: this.rowActions,
  });

  loading = this.isComLoading?.getValue() ?? false;
  data: Participant[] = [];
  ngOnInit() {
    this.meetingRepository.getNestedObservable<Participant[]>('dto', 'participants').subscribe(participants => {
      this.data = participants;
    });

    if (this.isStatusPlanned) {
      this.dataTableObject = getInvitationDataTableStructure({
        createAction: undefined,
        rowActions: undefined,
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isComLoading'] && this.isComLoading) {
      this.loading = this.isComLoading?.getValue() ?? false;
    }
  }

  removeParticipant(participant: Participant) {
    const participants = this.meetingRepository.getNested<Participant[]>('dto', 'participants');
    this.meetingRepository.setNested(
      'dto',
      'participants',
      participants.filter(p => p.userId !== participant.userId || p.mail !== participant.mail)
    );
  }
}
